export default "__VITE_ASSET__03369765__"